import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuggestionCarouselComponent } from './suggestion-carousel.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@xref/ngx';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslateModule,
    MatButtonModule
  ],
  declarations: [SuggestionCarouselComponent],
  exports: [SuggestionCarouselComponent]
})
export class SuggestionCarouselModule {}
